import { Box, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import styles from "@/components/lms/lmsIntervalValue.module.css";

interface Props {
  value?: number | string | null;
  inheritedFrom?: string | null;
}

export const getEnrolmentTableIntervalInheritedFrom = (
  source?: string | null
): string | null => (source === "enrolment" ? "enrolment" : null);

export default function LmsIntervalValue({ value, inheritedFrom }: Props) {
  const { t } = useTranslation();

  if (value == null || value === "") {
    return <>-</>;
  }

  if (!inheritedFrom || inheritedFrom === "course") {
    return <>{String(value)}</>;
  }

  const customIntervalLabel = t("custom_interval_tooltip");

  return (
    <Box component="span" className={styles.intervalValueWrapper}>
      <span>{value}</span>
      <Tooltip title={customIntervalLabel} placement="top" arrow>
        <span
          aria-label={customIntervalLabel}
          className={styles.inheritedValueIcon}
          tabIndex={0}
        >
          ⓘ
        </span>
      </Tooltip>
    </Box>
  );
}
